import { render, staticRenderFns } from "./printvisa.vue?vue&type=template&id=b2c31f70&scoped=true&"
import script from "./printvisa.vue?vue&type=script&lang=js&"
export * from "./printvisa.vue?vue&type=script&lang=js&"
import style0 from "./printvisa.vue?vue&type=style&index=0&id=b2c31f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2c31f70",
  null
  
)

export default component.exports